import React, { useContext, useState, useEffect } from 'react'
import { Scan, Globe, Menu, Music4, Star, Link2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { shareCantique } from '../utils/shareCantique';
import Projections from '../cantiques/Projections';
import CantiquesDetails from '../cantiques/CantiquesDetails';
import { CantiqueContextAPI } from '../Context/CantiqueContext';
import Lector from '../cantiques/Lector';
import { hasCantiqueAudio } from '../utils/cantiqueAudio';

const HomeDisplayCantique = () => {
  const { selectedCantique, setSidebarOpen, isFavorite, toggleFavorite } = useContext(CantiqueContextAPI);
  const [showProjection, setShowProjection] = useState(false);
  const [showLector, setShowLector] = useState(true);

  const cantiqueHasAudio = hasCantiqueAudio(selectedCantique);
  const favorite = selectedCantique ? isFavorite(selectedCantique.id) : false;

  const handleShare = async () => {
    const result = await shareCantique(selectedCantique);
    if (result === 'copied') toast.success('Lien du cantique copié');
  };

  const handleOpenProjection = async () => {
    setShowProjection(true);
    try {
      await document.documentElement.requestFullscreen();
    } catch (error) {
      console.error('Impossible d’activer le plein écran:', error);
    }
  };

  useEffect(() => {
    if (selectedCantique) {
      setShowLector(hasCantiqueAudio(selectedCantique));
    }
  }, [selectedCantique?.id]);

  if (!selectedCantique) {
    return null;
  }

  return (
    <div className="homeDisplaycantique">
        <div className="homeDisplaycantique__container">
            <header className="homeDisplaycantique__header">
                <div className="homeDisplaycantique__header__left">
                    <h2 className="homeDisplaycantique__title">
                        <span>{`${selectedCantique.number ?? ''}${selectedCantique.number ? '.' : ''}`}</span>
                        <span>{selectedCantique.title}</span>
                    </h2>
                    <div className="homeDisplaycantique__title-sub">
                         <span><Globe size={13} /></span>
                         <span>{selectedCantique.langue || 'Non spécifiée'}</span>
                         <span className="homeDisplaycantique__actions">
                           <button
                             type="button"
                             className={`homeDisplaycantique__action ${favorite ? 'is-active' : ''}`}
                             onClick={() => toggleFavorite(selectedCantique.id)}
                             aria-pressed={favorite}
                             aria-label={favorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                             title={favorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                           >
                             <Star size={14} fill={favorite ? 'currentColor' : 'none'} />
                           </button>
                           <button
                             type="button"
                             className="homeDisplaycantique__action"
                             onClick={handleShare}
                             aria-label="Partager le lien de ce cantique"
                             title="Partager le lien"
                           >
                             <Link2 size={14} />
                           </button>
                         </span>
                    </div>
                </div>
                                <div className="homeDisplaycantique__right">
                                         {/* projection button for desktop */}
                                         <div 
                                                className="homeDisplaycantique__projection"
                                                role="button"
                                                tabIndex={0}
                                                onClick={handleOpenProjection}
                                         >
                                                        <span>Projection</span>
                                                        <span className='homeDisplaycantique__projection__icon'><Scan size={15} /></span>
                                         </div>

                                         {cantiqueHasAudio && (
                                           <div
                                             className={`homeDisplaycantique__projection--audio ${showLector ? 'homeDisplaycantique__projection--audio-active' : ''}`}
                                             role="button"
                                             tabIndex={0}
                                             onClick={() => setShowLector(true)}
                                             onKeyDown={(e) => {
                                               if (e.key === 'Enter' || e.key === ' ') {
                                                 e.preventDefault()
                                                 setShowLector(true)
                                               }
                                             }}
                                             title={showLector ? 'Lecteur audio ouvert' : 'Ouvrir le lecteur audio'}
                                           >
                                             <span className='homeDisplaycantique__projection__icon'><Music4 size={16} /></span>
                                           </div>
                                         )}

                                         {/* burger for mobile: opens the Sidebard */}
                                         <button
                                             className="homeDisplaycantique__burger"
                                             aria-label="Ouvrir le menu"
                                             onClick={() => setSidebarOpen(true)}
                                         >
                                             <Menu size={20} />
                                         </button>
                                </div>
            </header>
            <div className="homeDisplaycantique__center">
                <CantiquesDetails />
                {cantiqueHasAudio && showLector && (
                  <Lector onClose={() => setShowLector(false)} />
                )}
            </div>
            <div className="homeDisplaycantique__footer">
                <p className="homeDisplaycantique__footer__text">
                    <span>Atmosphere-ALCM</span> - 2024. Tous droits réservés.
                     <span>Contactez-nous</span>
                </p>
            </div>
        </div>
        <Projections isOpen={showProjection} onClose={() => {
          setShowProjection(false);
          document.exitFullscreen().catch(() => {});
        }} />
    </div>
  )
}

export default HomeDisplayCantique